import React from "react";
import { CustomBox } from "../../Shared/CustomBox/CustomBox";
import { CustomTypography } from "../../Shared/CustomTypography/CustomTypography";

interface InfoRowProps {
  label: string;
  value: string;
}

export const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => (
  <CustomBox justifyContent="space-between" mb={1}>
    <CustomTypography fontSize={13} color="gray">
      {label}
    </CustomTypography>
    <CustomTypography fontSize={13}>{value}</CustomTypography>
  </CustomBox>
);
